import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MainHeader from "../components/MainHeader";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";

  useEffect(() => {
    document.body.classList.remove("theme-mini");
  }, []);
  useEffect(() => {
    if (user && user.id) navigate(redirect);
  }, [user, navigate, redirect]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back to the theater.");
      navigate(redirect);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-gs-cream">
      <MainHeader />
      <div className="max-w-md mx-auto px-6 py-20">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gs-ember">Will-call</p>
        <h1 className="font-serif text-5xl text-gs-ink mt-3 leading-tight">Sign in</h1>
        <p className="font-sans text-gs-ink/70 mt-3">Welcome back. Your tickets are waiting.</p>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-gs-dust mb-2">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-white border border-gs-line px-4 py-3 font-sans focus:outline-none focus:border-gs-ember"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-gs-dust mb-2">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-white border border-gs-line px-4 py-3 font-sans focus:outline-none focus:border-gs-ember"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-btn"
            className="w-full bg-gs-ink text-gs-cream py-3 font-mono uppercase tracking-[0.25em] text-xs border border-gs-ember/50 hover:bg-gs-ember hover:text-gs-ink rounded-none transition-colors disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="font-sans text-sm text-gs-ink/60 mt-6">
          New here? <Link to="/register" className="text-gs-ember underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
